export default {"src":"/_next/static/media/card.166419cc.svg","height":100,"width":150};